"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronLeft = function ChevronLeft(props) {
  return _react2.default.createElement(
    "svg",
    (0, _extends3.default)({ width: 18, height: 18, viewBox: "0 0 18 18" }, props),
    _react2.default.createElement("path", { d: "M10.626 11.563v2.617L6 9.09 10.626 4v2.617L8.378 9.09z" })
  );
};

exports.default = ChevronLeft;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/icons/ChevronLeft.js
// module id = 687
// module chunks = 0